import { dictionary } from 'svelte-i18n';
    

dictionary.set({
    en: {
        "assign": "assign",
        "assign_user_role": "Add Role",
        "back": "back",
        "cancel": "cancel",
        "confirm": "confirm",
        "create": "create",
        "delete": "delete",
        "edit": "edit",
        "email": "E-Mail Adress",
        "firstname": "Firstname",
        "home": "Home",
        "incorrect": "incorrect",
        "invalid": "invalid",
        "language": "language",
        "lastname": "Lastname",
        "login": "login",
        "logout": "logout",
        "name": "name",
        "no": "No",
        "not-provided": "not provided",
        "ok": "OK",
        "open": "open",
        "overview": "overview",
        "password": "password",
        "permission": "Permission",
        "profile": "profile",
        "register": "register",
        "remove": "remove",
        "role": "Role",
        "rolse": "Roles",
        "save": "save",
        "search": "search",
        "select": "select",
        "to": "to",
        "todos": "todos",
        "unknown_error": "unknown error",
        "update": "update",
        "user": "User",
        "user_role": "User Role",
        "user_roles": "User Roles",
        "users": "Users",
        "yes": "Yes",

        "permission_denied": "Permission denied",
        "invalid_arguments": "invalid arguments",
        "same_request_to_soon": "stopped duplicate request",
        "missing": "missing",
        "error": "error",
        "permissions": "Permissions",

        "function-call-failed": "Function call failed",
        "not-found": "not found ",
        "doesnt-exist": "doesn't exist",
        "user-role-assigned": "This user role ist assigned",

        "new-role": "New User Role",
        "new-permission": "New permission",
        "role-permission-assigned": "This permission is still assinged to a Role",
        "user-permission-assigned": "This permission is still assinged to a User",
        "edit-permission": "Edit permission",
        "edit-role": "Edit User Role",
        "duplicate": "already in use",
        "settings": "Settings",
        "email_not_verified": "Your E-Mail Adress hasn't been verified",
        "verify_email": "Verify E-Mail Adress",
        "email_send": "E-Mail send",
        "swal_confirm_email": "You will shortly receive an E-Mail to verify your E-Mail Adress",

        "confirm_remove_user_role_1": "Remove User Role",
        "confirm_remove_user_role_2": "Do you realy want to delete this Role?",

    },
    de: {
        "assign": "hinzufügen",
        "assign_user_role": "Rolle hinzufügen",
        "back": "Zurück",
        "cancel": "Abbrechen",
        "confirm": "bestätigen",
        "create": "Anlegen",
        "delete": "Löschen",
        "edit": "Bearbeiten",
        "email": "E-Mail Adresse",
        "email_confirm": "E-Mail Adresse",
        "firstname": "Vorname",
        "home": "Home",
        "incorrect": "nicht richtig",
        "invalid": "ungültig",
        "language": "Sprache",
        "lastname": "Nachname",
        "login": "Login",
        "logout": "Logout",
        "name": "Name",
        "no": "Nein",
        "not-provided": "nicht angegeben",
        "ok": "OK",
        "open": "öffnen",
        "overview": "Übersicht",
        "password": "Passwort",
        "password_confirm": "Passwort",
        "permission": "Berechtigung",
        "profile": "Profil",
        "register": "Registrieren",
        "remove": "entfernen",
        "role": "Rolle",
        "rolse": "Rollen",
        "save": "Speichern",
        "search": "Suche",
        "select": "Auswählen",
        "to": "zu",
        "todos": "Todos",
        "unknown_error": "Unbekannter Fehler",
        "update": "aktualisieren",
        "user": "Benutzer",
        "user_role": "Benutzerrolle",
        "user_roles": "Benutzerrollen",
        "users": "Benutzer",
        "yes": "Ja",

        "permission_denied": "Keine berechtigung",

        "invalid_arguments": "ungültige Angaben",
        "same_request_to_soon": "Doppelte Anfrage verhindert",
        "missing": "fehlt",
        "error": "Fehler",
        "permissions": "Berechtigungen",

        "function-call-failed": "Funktionsaufruf fehlgeschlagen",
        "not-found": "nicht gefunden",
        "doesnt-exist": "existiert nicht gefunden",
        "user-role-assigned": "Diese Rolle ist einem Benutzer zugewiesen",

        "new-role": "Neue Benutzerrolle",
        "new-permission": "Neue Berechtigung",
        "role-permission-assigned": "Diese Berechtigung ist noch einer Benutzerrolle zugewiesen",
        "user-permission-assigned": "Diese Berechtigung ist noch einem Benutzer zugewiesen",
        "edit-permission": "Berechtigung bearbeiten",
        "edit-role": "Benutzerrolle bearbeiten",
        "duplicate": "bereits verwendet",

        "settings": "Einstellungen",
        "email_not_verified": "Ihre E-Mail Adresse ist nicht verifiziert",
        "verify_email": "E-Mail Adresse verifizieren",
        "email_send": "E-Mail versendet",
        "swal_confirm_email": "Sie erhalten in kürze eine E-Mail um Ihre E-Mail Adresse zu bestätigen",

        "confirm_remove_user_role_1": "Benutzerrolle entfernen",
        "confirm_remove_user_role_2": "Soll die Benutzerrolle wirklich entfernt werden?",
    
    },
    fr: {
        "home": "Tutoriel"
    },
});
